import useIpAddress from 'hooks/useIpAddress'
import { useTranslation } from 'next-i18next'

const BANNER_WRAPPER_CLASSES =
  'shared-container mt-4 flex flex-wrap items-center justify-center bg-th-bkg-1 px-10 py-4'

// const LINK_TEXT_CLASSES =
//   'bg-gradient-to-b from-mango-classic-theme-active to-mango-classic-theme-down bg-clip-text font-bold text-transparent'

const TEXT_CLASSES = 'mx-1 text-center text-th-fgd-3 text-xs'

const WarningBanner = () => {
  const { showWarning } = useIpAddress()
  const { t } = useTranslation('messages')

  return showWarning ? <BannerContent text={t('waning-banner')} /> : null
}

export default WarningBanner

const BannerContent = ({
  text,
}: {
  text: string
  // linkText?: string
  // onClickLink?: () => void
  // onClose?: () => void
}) => {
  return (
    <div className="relative">
      <div className={BANNER_WRAPPER_CLASSES}>
        <p className={TEXT_CLASSES}>{text}</p>
        {/* <Link
          className={LINK_TEXT_CLASSES}
          href="https://docs.mango.markets/mango-markets/risks"
          onClick={onClickLink}
          target="blank"
        >
          {linkText}
        </Link> */}
      </div>
      {/* {onClose ? (
        <IconButton
          className="absolute right-0 top-1/2 -translate-y-1/2 sm:right-2"
          hideBg
          onClick={onClose}
          size="medium"
        >
          <XMarkIcon className="h-5 w-5 text-th-fgd-3" />
        </IconButton>
      ) : null} */}
    </div>
  )
}
